module.exports = __webpack_public_path__ + "img/lsj1.4efe4127.png";